import { request } from '../client';

// The offers listed at the outlet serving the browsing location, for this
// storefront. The backend resolves the outlet from the X-Delivery-* headers and
// the channel from X-Client-Channel (both set centrally by the client), and
// returns only offers that run on the website — nothing is filtered here. With
// no serving outlet it returns an empty list. Geography-sensitive: an answer
// for a previous browsing location rejects with STALE_DELIVERY_GEOGRAPHY.
export const listOffers = (options = {}) => request('/offers', { geographySensitive: true, ...options });
